<template>
  <div class="lottery">
    <div class="content">
      <div class="content-up">
        <div class="left">
          <div class="left-wrap" v-if="awardBullets.length > 0">
            <div class="list" v-for="(item, index) in awardBullets" :key="index">{{ item }}</div>
          </div>
          <div class="empty" v-else>
            <img src="@/assets/img/empty/no-data.png" alt="" />
            <div>暂无中奖名单</div>
          </div>
        </div>
        <div class="mid">
          <div class="wrap">
            <div
              :ref="`item${item.order}`"
              :class="[index === 5 || index === 6 ? 'list-empty' : 'list']"
              v-for="(item, index) in awardList"
              :key="item.id"
            >
              <img v-if="index !== 5 && index !== 6" :src="item.award_pic ? item.award_pic : require('@/assets/img/service_icon.png')" alt="" />
              <div v-if="index !== 5 && index !== 6" class="a">{{ item.name }}</div>
              <div v-if="index !== 5 && index !== 6" class="b">{{ item.lott_num + item.unit }}</div>
            </div>
          </div>
          <div class="control">
            <div class="a">
              <div class="btn" @click="startLottery(2)">
                <div class="btn-up">点击夺宝</div>
                <div class="btn-down">{{ diamondCost }}克拉/次</div>
              </div>
              <div v-if="freeTimes > 0" class="btn" @click="startLottery(3)">
                <div class="btn-up">免费夺宝</div>
                <div class="btn-down">剩余{{ freeTimes }}次</div>
              </div>
              <div v-else class="btn" @click="startLottery(1)">
                <div class="btn-up">点击夺宝</div>
                <div class="btn-down">{{ goldCost }}鹰钻/次</div>
              </div>
            </div>
            <div class="b">我的钱包</div>
            <div class="c">
              <div class="c-left">
                <img src="./img/diamond.png" alt="" />
                <div>{{ userInfo.diamond / 100 ? (userInfo.diamond / 100).toLocaleString() : 0 }}</div>
              </div>
              <div class="c-right">
                <img src="./img/gold.png" alt="" />
                <div>{{ userInfo.gold / 100 ? (userInfo.gold / 100).toLocaleString() : 0 }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <img class="service" @click="toService" src="./img/service.png" alt="" />
          <div class="right-wrap" v-if="lotteryHistory.length > 0">
            <div class="list" v-for="(item, index) in lotteryHistory" :key="index" v-if="!item.express_no">
              <div class="list-a">
                <img :src="item.award_pic" alt="" />
              </div>
              <div class="list-b">
                <div class="up">{{ item.name + "x" + item.lott_num }}</div>
                <div class="down" v-show="item.express_no">{{ "运单号码：" + item.express_no }}</div>
              </div>
              <div class="list-c">
                <div class="up">{{ item.give_time }}</div>
                <div class="down" :style="{ color: item.delivery_status.indexOf('已发') > -1 ? '#33CC00' : '#FFDF39' }">
                  {{ item.delivery_status }}
                </div>
              </div>
            </div>
            <!-- 样式布局调整 -->
            <div class="list-bak" v-for="(item, index) in lotteryHistory" :key="index" v-if="item.express_no">
              <div class="list-bak-a">
                <img :src="item.award_pic" alt="" />
              </div>
              <div class="list-bak-b">
                <div class="list-bak-b-up">
                  <div>{{ item.name + "x" + item.lott_num }}</div>
                  <div>{{ item.give_time }}</div>
                </div>
                <div class="list-bak-b-down">
                  <div class="list-bak-b-down-left text-overflow" v-show="item.express_no" :data-clipboard-text="item.express_no" @click="copy()">
                    {{ "运单号码：" + item.express_no }}
                  </div>
                  <div class="list-bak-b-down-right" :style="{ color: item.delivery_status.indexOf('已发') > -1 ? '#33CC00' : '#FFDF39' }">
                    {{ item.delivery_status }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="empty" v-else>
            <img src="@/assets/img/empty/no-data.png" alt="" />
            <div>暂无中奖记录</div>
          </div>
        </div>
      </div>
      <div class="content-down">
        <div class="rule">
          <div class="title">猎鹰夺宝活动规则：</div>
          <p>1、点击夺宝按钮即可进行夺宝，每点击按钮一次消耗一次克拉或鹰钻；</p>
          <p>
            2、抽中的实物奖品，收获地址以用户提供的信息为准，已登记奖品无法更改地址，用户原因导致的奖品未收到（如信息提交错误，超期申请，地址信息错误，手机联系不上等），损失有用户承担，奖品不予补发，
            视为用户自动放弃奖品；
          </p>
          <p>3、奖品「道具」会下发至「我的背包」，可进行装备；</p>
          <p>4、奖品「礼物」会下发至「我的背包」，可在直播间内赠送给心仪的主播；</p>
          <p>5、奖品「克拉和鹰钻」会自动下发至「我的钱包」。</p>
        </div>
        <div class="rule" style="margin-top: 0.4rem">
          <div class="title">注意：</div>
          <p>1、猎鹰可根据本活动的实际举办情况对活动规则进行变动或调整，相关变动或调整将公布在活动页面上公布后已发生效；</p>
          <p>2、本活动期间，如用户存在违规行为（包括但不限于恶意套现、机器作弊等），猎鹰将取消用户中奖资格，收回奖品，同时依照相关规则进行处罚。</p>
          <p>注：以上服务仅限于中国大陆地区，详细咨询官方在线客服。</p>
        </div>
      </div>
    </div>
    <el-dialog top="30vh" title="" :visible.sync="chargeDiamond" class="first-gift-dialog">
      <div class="charge-diamond">
        <div class="row1">您的克拉余额不足</div>
        <div class="row3">
          <div class="btn" @click="chargeDiamond = false">取消</div>
          <div class="btn btn-active" @click="goChargeDiamond">立即充值</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog top="30vh" title="" :visible.sync="chargeGold" class="first-gift-dialog">
      <div class="charge-diamond charge-gold">
        <div class="row1">
          <p>您的鹰钻余额不足</p>
          <p>做任务赚取鹰钻</p>
        </div>
        <div class="row3">
          <div class="btn" @click="chargeGold = false">取消</div>
          <div class="btn btn-active" @click="goChargeGold">做任务</div>
        </div>
      </div>
    </el-dialog>
    <LotteryWinDialog :reward="reward" ref="lotteryDialog" />
    <Footer />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { post } from "../../util/http";
import Footer from "@/components/footer/footer";
import LotteryWinDialog from "@/components/dialog/LotteryWinDialog";
import Cipboard from "clipboard";
export default {
  name: "lottery",
  components: { Footer, LotteryWinDialog },
  computed: {
    ...mapState(["userInfo", "appConfig"]),
  },
  props: {},

  data() {
    return {
      reward: {},
      awardList: [],
      lotteryId: 0,
      diamondCost: 0,
      goldCost: 0,
      freeTimes: 0,
      lottery: {
        count: 10, //总共有多少个位置
        timer: 0, //setTimeout的ID，用clearTimeout清除
        speed: 35, //初始转动速度
        times: 0, //转动次数
        cynum: 50, // 圈数
        win: 5, //中奖位置 0 默认不中奖
      },
      index: 1, //当前转动到哪个位置，起点位置
      lotterywin: 0, // 中奖位置
      awardBullets: [],
      loopAwardTimer: null,
      lotteryHistory: [],
      chargeDiamond: false,
      chargeGold: false,
      isLotteryStart: false,
    };
  },
  created() {},
  destroyed() {
    clearInterval(this.loopAwardTimer);
  },
  mounted() {
    this.getLottery();
    this.loopAward();
    this.getLotteryHistory();
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    copy() {
      console.log("copy");
      var copyBtn = new Cipboard(".list-bak-b-down-left");
      copyBtn.on("success", (e) => {
        this.$message.success("复制成功");
        copyBtn.destroy();
      });
    },
    toService() {
      window.open(this.appConfig.service_url, "_blank");
    },
    goChargeDiamond() {
      this.$router.push("/user-center/recharge");
    },
    goChargeGold() {
      this.$router.push("/home");
    },
    getLotteryHistory() {
      post({
        url: "/api/lottery/getLotteryHistory",
      })
        .then(({ data }) => {
          if (data.status === 0) {
            this.lotteryHistory = data.data || [];
          }
        })
        .catch((err) => console.log("err", err));
    },
    loopAward() {
      this.getAwardBullets();
      this.loopAwardTimer = setInterval(() => {
        this.getAwardBullets();
      }, 10000);
    },
    getAwardBullets() {
      post({
        url: "/api/lottery/getAwardBullets",
      })
        .then(({ data }) => {
          if (data.status === 0) {
            this.awardBullets = data.data || [];
          }
        })
        .catch((err) => console.log("err", err));
    },
    startLottery(type) {
      if (this.isLotteryStart) return;
      this.isLotteryStart = true;
      if (this.userInfo.diamond < this.diamondCost * 100 && type === 2) {
        this.chargeDiamond = true;
        return;
      }
      if (this.userInfo.gold < this.goldCost * 100 && type === 1) {
        this.chargeGold = true;
        return;
      }
      post({
        url: "/api/lottery/drawLottery",
        data: {
          draw_type: type,
          lott_id: this.lotteryId,
        },
      })
        .then(({ data }) => {
          if (data.status === 0) {
            if (data.data.is_succeed) {
              this.getUserInfo();
              this.getLotteryAwardsInfo();
              this.reward = data.data || {};
              this.awardList.forEach((e) => {
                if (e.id === data.data.award_id) {
                  this.lotterywin = e.order;
                }
              });
              if (this.lotterywin) {
                this._rolling();
              }
            } else {
              this.$message.console.error(data.data.fail_tip);
            }
          }
        })
        .catch((err) => console.log("err", err));
    },
    getLottery() {
      post({
        url: "/api/lottery/getLottery",
      })
        .then(({ data }) => {
          if (data.status === 0) {
            this.lotteryId = data.data.lott_id;
            if (!data.data.is_lott_exists) {
              this.$message.warning("活动已结束");
              return;
            }
            this.getLotteryAwardsInfo();
          }
        })
        .catch((err) => console.log("err", err));
    },
    getLotteryAwardsInfo() {
      post({
        url: "/api/lottery/getLotteryAwardsInfo",
        data: {
          lott_id: this.lotteryId,
        },
      })
        .then(({ data }) => {
          if (data.status === 0) {
            this.awardList = data.data.award_list;
            let order = 1;
            this.awardList.forEach((e) => {
              e.order = order;
              order++;
            });
            this.diamondCost = data.data.diamond_cost / 100;
            this.goldCost = data.data.gold_cost / 100;
            this.freeTimes = data.data.free_draw_times;
            this.changeListOrder();
            console.log(this.awardList);
          }
        })
        .catch((err) => console.log("err", err));
    },
    changeListOrder() {
      let orderList = [1, 2, 3, 4, 10, -1, -2, 5, 9, 8, 7, 6];
      const keyObj = {};
      const arr = [];
      const downArr = Object.assign([], this.awardList);
      if (downArr.length) {
        downArr.push({ order: -1 });
        downArr.push({ order: -2 });
        downArr.forEach((element) => {
          keyObj[element.order] = element;
        });
        // 依据数组的顺序填充
        orderList.forEach((ele) => {
          arr.push(keyObj[ele]);
        });
      }
      this.awardList = arr;
    },
    _rolling() {
      this.lottery.times++;
      this._roll_actived(); // 设置状态
      // +10 将速度降下来的圈数周期
      if (this.lottery.times > this.lottery.cynum + 10 && this.lotterywin === this.index) {
        clearTimeout(this.lottery.timer);
        setTimeout(() => {
          this.$refs.lotteryDialog.open();
          // this.$message.success("获得" + this.reward.name + this.reward.lott_num + this.reward.unit);
          this.getAwardBullets();
          this.getLotteryHistory();
          this.isLotteryStart = false;
          this.lottery = {
            count: 10, //总共有多少个位置
            timer: 0, //setTimeout的ID，用clearTimeout清除
            speed: 35, //初始转动速度
            times: 0, //转动次数
            cynum: 50, // 圈数
          };
        }, 1000); // 此时间给予用户感受中奖反馈时间
      } else {
        if (this.lottery.times > this.lottery.cynum) this.lottery.speed += 20; // 惯性 越来越慢
        this.index++;
        this.lottery.timer = setTimeout(this._rolling, this.lottery.speed);
      }
    },
    _roll_actived() {
      // running 选中的状态
      let pre = this.index - 1;
      if (this.index > this.lottery.count) this.index = 1;
      const preDom = this.$refs["item" + pre];
      const downDom = this.$refs["item" + this.index];
      if (pre > 0 && preDom) {
        preDom[0].classList.remove("active");
      }
      if (downDom) {
        downDom[0].classList.add("active");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.lottery {
  margin-top: 0.66rem;
  background: url("./img/lottery-bg.png") no-repeat;
  background-size: 100%;
  background-color: #ffffff;
}
.content {
  width: 14rem;
  margin: 3.6rem auto 0.5rem;

  .content-up {
    display: flex;
    align-items: center;
    .left {
      width: 3rem;
      height: 5.7rem;
      background: url("./img/win-list.png") no-repeat;
      background-size: 100% 100%;
      padding: 1rem 0.12rem 0.22rem;
      .left-wrap {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 0.14rem;
        color: #ffffff;
        overflow: scroll;

        .list {
          margin-bottom: 0.32rem;
        }
      }
      .empty {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        font-size: 0.16rem;
        img {
          width: 1.3rem;
          margin-bottom: 0.2rem;
        }
      }
    }
    .mid {
      width: 8.04rem;
      height: 6.8rem;
      background: url("./img/lottery.png") no-repeat;
      background-size: 100% 100%;
      position: relative;
      .wrap {
        position: absolute;
        top: 0.67rem;
        left: 0.35rem;
        width: 7.5rem;
        display: flex;
        flex-wrap: wrap;
        .list {
          width: 1.78rem;
          height: 1.78rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          background: radial-gradient(50% 50% at 50% 50%, #ffffff 0%, #e9e1ff 100%);
          border: 1px solid #090968;
          box-shadow: inset 0px -0.12rem 0px rgba(123, 98, 211, 0.75);
          border-radius: 0.06rem;
          padding-top: 0.35rem;
          margin-right: 0.06rem;
          margin-bottom: 0.06rem;
          color: #44387f;
          img {
            height: 0.58rem;
          }
          .a {
            font-weight: 500;
            font-size: 0.18rem;
            margin-top: 0.1rem;
          }
          .b {
            font-size: 0.16rem;
            margin-top: 0.06rem;
          }
        }
        .list-empty {
          width: 1.78rem;
          height: 1.78rem;
          margin-right: 0.06rem;
        }
        .active {
          background: #fcf3ff;
          border: 0.04rem solid #ffda48;
          box-shadow: 0px 0.02rem 0.05rem rgba(255, 249, 147, 0.25), inset 0px -0.04rem 0px #ffeca2;
        }
      }
      .control {
        width: 3.62rem;
        height: 1.78rem;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        padding: 0.05rem;
        .a {
          display: flex;
          justify-content: space-between;
          .btn {
            width: 1.66rem;
            height: 0.9rem;
            background: radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0.6) 20%, rgba(0, 0, 0, 0.6) 100%), #ffd73f;
            background-blend-mode: overlay, normal;
            box-shadow: inset -1px 0px 0px rgba(255, 255, 255, 0.5), inset 1px 0px 0px rgba(255, 255, 255, 0.5),
              inset 0px -0.05rem 0px rgba(218, 105, 13, 0.75), inset 0px 3px 0px rgba(255, 255, 255, 0.5);
            border-radius: 0.1rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            padding-top: 0.2rem;
            padding-bottom: 0.16rem;
            color: rgba(142, 25, 0, 0.8);
            cursor: pointer;
            .btn-up {
              font-size: 0.28rem;
            }
            .btn-down {
              font-size: 0.14rem;
            }
          }
        }
        .b {
          color: #ffffff;
          margin-top: 0.2rem;
          margin-bottom: 0.05rem;
        }
        .c {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 0.15rem;
          width: 100%;
          height: 0.36rem;
          background: linear-gradient(90deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.3) 50.2%, rgba(255, 255, 255, 0.15) 100%);
          border-radius: 0.36rem;
          font-size: 0.2rem;
          color: #ffffff;
          .c-left {
            display: flex;
            align-items: center;
          }
          .c-right {
            display: flex;
            align-items: center;
          }
          img {
            width: 0.24rem;
            margin-right: 0.04rem;
          }
        }
      }
    }
    .right {
      width: 3rem;
      height: 5.7rem;
      background: url("./img/win-history.png") no-repeat;
      background-size: 100% 100%;
      padding: 0.85rem 0.28rem 0.22rem;
      position: relative;
      .service {
        width: 0.24rem;
        position: absolute;
        top: 22px;
        right: 22px;
        cursor: pointer;
      }
      .right-wrap {
        width: 100%;
        height: 100%;
        font-size: 0.14rem;
        color: #ffffff;
        overflow: scroll;
        .list {
          width: 100%;
          height: 0.8rem;
          display: flex;
          align-items: center;
          // justify-content: space-between;
          border-bottom: 0.01rem solid #db0005;
          .list-a {
            width: 0.44rem;
            height: 0.44rem;
            background: radial-gradient(50% 50% at 50% 50%, #c2001d 0%, #8a0012 100%);
            border-radius: 0.08rem;
            padding: 0.08rem;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 100%;
            }
          }

          .list-b {
            margin-left: 0.12rem;
            .down {
              max-width: 1.28rem;
              margin-top: 0.1rem;
              font-size: 0.12rem;
            }
          }
          .list-c {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            .down {
              margin-top: 0.1rem;
              color: #ffdf39;
            }
          }
        }
        .list-bak {
          width: 2.43rem;
          height: 0.8rem;
          display: flex;
          align-items: center;
          border-bottom: 0.01rem solid #db0005;
          .list-bak-a {
            width: 0.44rem;
            height: 0.44rem;
            background: radial-gradient(50% 50% at 50% 50%, #c2001d 0%, #8a0012 100%);
            border-radius: 0.08rem;
            padding: 0.08rem;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 0.12rem;
            img {
              width: 100%;
            }
          }
          .list-bak-b {
            width: 1.87rem;
            display: flex;
            flex-direction: column;
            .list-bak-b-up {
              display: flex;
              justify-content: space-between;
            }
            .list-bak-b-down {
              display: flex;
              justify-content: flex-end;
              margin-top: 0.1rem;
              .list-bak-b-down-left {
                flex: 1;
                font-size: 0.12rem;
                cursor: pointer;
              }
            }
          }
        }
      }
      .empty {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        font-size: 0.16rem;
        img {
          width: 1.3rem;
          margin-bottom: 0.2rem;
        }
      }
    }
  }
  .content-down {
    width: 14rem;
    height: 5.03rem;
    background: url("./img/rule.png") no-repeat;
    background-size: 100% 100%;
    padding: 1.1rem 0.44rem 0.12rem;
    color: #ffffff;
    .title {
      font-size: 0.16rem;
      color: #ffdf39;
      margin-bottom: 0.05rem;
    }
    p {
      line-height: 0.3rem;
    }
  }
}

::v-deep {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog {
    width: 3.55rem;
    border-radius: 0.1rem;
  }
}
.charge-diamond {
  height: 1.64rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 0.4rem 0 0.28rem;
  .row1 {
    font-size: 0.16rem;
    color: #333333;
    text-align: center;
    line-height: 0.22rem;
  }
  .row3 {
    display: flex;
    align-items: center;
    justify-content: center;
    .btn {
      width: 1.12rem;
      height: 0.34rem;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666666;
      font-size: 0.16rem;
      color: #02a8a2;
      border: 1px solid #02a8a2;
      border-radius: 1rem;
      cursor: pointer;
    }
    .btn-active {
      background: #02a8a2;
      color: #ffffff;
      margin-left: 0.24rem;
    }
  }
}
.charge-gold {
  height: 1.86rem;
}
</style>
